import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type {
  ExternalWorkIntegrationStatusValues,
  WorkIntegrationResponse,
} from '@/lib/api/types/work-integrations';
import { WorkIntegrationsApi } from '@/lib/api/work-integrations/work-integrations';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';
import { associateById } from '@/lib/utils/common/associateById';

export const useGetAllWorkIntegrations = (
  queryOptions: Omit<UseQueryOptions<WorkIntegrationResponse[], Error>, 'queryFn' | 'queryKey'> & {
    onSuccess?: (data: WorkIntegrationResponse[]) => void;
  } = {},
  apiOptions?: {
    limit?: number;
    filter?: {
      statuses?: ExternalWorkIntegrationStatusValues[];
      ids?: number[];
      loopIds?: number[];
    };
  },
) => {
  return useQuery<WorkIntegrationResponse[], Error>({
    queryKey: workIntegrationsQueryKeys.workIntegrationsAll(apiOptions),
    queryFn: () => WorkIntegrationsApi.getAllWorkIntegrations(apiOptions),
    ...queryOptions,
  });
};

export const useGetAllWorkIntegrationsById = (
  queryOptions: Omit<
    UseQueryOptions<WorkIntegrationResponse[], Error, Record<number, WorkIntegrationResponse>>,
    'queryFn' | 'queryKey'
  > = {},
  apiOptions?: {
    limit?: number;
    filter?: {
      statuses?: ExternalWorkIntegrationStatusValues[];
      ids?: number[];
      loopIds?: number[];
    };
  },
) => {
  return useQuery<WorkIntegrationResponse[], Error, Record<number, WorkIntegrationResponse>>({
    queryKey: workIntegrationsQueryKeys.workIntegrationsAll(apiOptions),
    queryFn: () => WorkIntegrationsApi.getAllWorkIntegrations(apiOptions),
    ...queryOptions,
    select: associateById,
  });
};
